import React from "react";
import { ButtonControl } from "spark-core-dx/components";

const WizardFooter = ({
  canCancelSetupFlow,
  showPreviousStepButton,
  showSaveButton,
  showCompleteAction,
  hidePrimaryAction,
  isLastStep,
  isComplete,
  saving,
  hasActiveSectionStep,
  activeSectionStepReadOnly,
  nextDisabled,
  primaryActionLabel,
  onCancelSetup,
  onPrevious,
  onSave,
  onNext,
  onComplete
}) => (
  <footer className="resource-wizard__footer">
    <div className="resource-wizard__footer-left">
      {canCancelSetupFlow ? (
        <ButtonControl
          type="cancel"
          className="resource-wizard__button resource-wizard__button--danger"
          onClick={onCancelSetup}
          disabled={saving}
          loading={saving}
        >
          Delete Setup
        </ButtonControl>
      ) : null}
      {showPreviousStepButton ? (
        <ButtonControl
          type="cancel"
          className="resource-wizard__button resource-wizard__button--secondary"
          onClick={onPrevious}
          disabled={saving}
          loading={saving}
        >
          &lt;&lt; Previous
        </ButtonControl>
      ) : null}
    </div>
    <div className="resource-wizard__footer-right">
      {showSaveButton ? (
        <ButtonControl
          type="cancel"
          className="resource-wizard__button resource-wizard__button--secondary"
          onClick={onSave}
          disabled={saving || !hasActiveSectionStep || activeSectionStepReadOnly}
          loading={saving}
        >
          Save
        </ButtonControl>
      ) : null}
      {hidePrimaryAction ? null : isLastStep && isComplete ? (
        <ButtonControl
          type="ok"
          className="resource-wizard__button resource-wizard__button--primary"
          disabled
        >
          Completed
        </ButtonControl>
      ) : isLastStep || showCompleteAction ? (
        <ButtonControl
          type="ok"
          className="resource-wizard__button resource-wizard__button--primary"
          onClick={onComplete}
          disabled={nextDisabled}
          loading={saving}
        >
          Complete
        </ButtonControl>
      ) : (
        <ButtonControl
          type="ok"
          className="resource-wizard__button resource-wizard__button--primary"
          onClick={onNext}
          disabled={nextDisabled}
          loading={saving}
        >
          {primaryActionLabel || "Next >>"}
        </ButtonControl>
      )}
    </div>
  </footer>
);

export default WizardFooter;
